import { createApp } from 'vue'
import App from './App.vue'
import './assets/css/tailwind.css'

// Initialize dataLayer for GTM
window.dataLayer = window.dataLayer || []
window.dataLayer.push({
  'gtm.start': new Date().getTime(),
  event: 'gtm.js'
})

// FontAwesome imports
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faBitcoin } from '@fortawesome/free-brands-svg-icons'
import { faFaceSmile } from '@fortawesome/free-regular-svg-icons'
library.add(faBitcoin)
library.add(faFaceSmile)
library.add(fas) // Adding all solid icons to the library for global use

// Other plugins/components
import globalMethods from './plugins/globalMethods'
import Notifications from 'notiwind'
import { useCartStore } from './composables/useCartStore'
import { initializeSettings, TWORK_SETTINGS, TWORK_INFO } from './utils/helper'

// --- Fetch configuration and initialize settings ---
async function fetchConfig () {
  try {
    const response = await fetch('https://webwire.cz/api/v2/brand/info', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({ brand_slug: 'zpl' })
    })

    if (!response.ok) {
      throw new Error('Network response was not ok')
    }

    const data = await response.json()
    if (data.status) {
      window.vueAppConfig = {
        endpoint: 'https://webwire.cz',
        info: data.data,
        settings: data.settings.event
      }
    //  console.log('Configuration fetched:', window.vueAppConfig)
      // Initialize settings after fetching configuration
      initializeSettings()
    } else {
      console.error('Failed to fetch configuration:', data)
    }
  } catch (error) {
    console.error('Fetch configuration failed:', error)
  }
}

async function initializeVueApp () {
  // Wait for the configuration to be fetched and settings initialized
  if (!window.vueAppConfig) {
    await fetchConfig()
  } else {
    initializeSettings()
  }

  // Determine the mount point based on configuration (or default to '#app')
  const webinarContainer = document.querySelector(
    window.vueAppConfig?.settings?.element_id || '#app'
  )
  const mountPoint = webinarContainer || '#app'

  // Dynamically import the router factory function after configuration is ready
  const { createAppRouter } = await import('./router')
  const router = createAppRouter()

  // Create the Vue application instance
  const app = createApp(App)

  // Register global components and plugins
  app.component('font-awesome-icon', FontAwesomeIcon)
  app.use(globalMethods)
  app.use(Notifications)
  app.use(router)

  // Provide the cart store globally
  const cartStore = useCartStore()
  app.provide('cartStore', cartStore)

  // Expose settings and info on the global properties
  app.config.globalProperties.$TWORK_SETTINGS = TWORK_SETTINGS
  app.config.globalProperties.$TWORK_INFO = TWORK_INFO

  // Mount the app to the determined DOM element
  app.mount(mountPoint)
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeVueApp)
} else {
  initializeVueApp()
}
